<template lang="pug">
  .contact.page
    main.content.col-6.col-offset-3.col-tp-8.col-tp-offset-2.col-m-12.col-m-offset-0
      p.txt.txtCenter.row(v-for="paragraph of contact.content.main") {{ paragraph }}

      form#form(@submit.prevent="checkForm").row
        //- message
        .field.msg(:class="{ show: form.status != null, error: form.status === false }")
          p {{ form.feedback }}
        //- name
        .col-6.col-m-12.field
          label(for="name") Olá, me chamo
          input#name(
            name="name",
            v-model="name",
            placeholder="digite seu nome",
            v-validate="'required|alpha_spaces'",
            :class="{'error': submitted && errors.has('name') }"
          )
          span.help(v-if="submitted") {{ errors.first('name') }}
        //- email
        .col-6.col-m-12.field
          label(for="email") meu e-mail é
          input#email(
            name="email",
            v-model="email",
            placeholder="digite seu e-mail",
            v-validate="'required|email'",
            :class="{'error': submitted && errors.has('email') }"
          )
          span.help(v-if="submitted") {{ errors.first('email') }}
        //- message
        .field.clearfix
          label(for="message") quero conversar sobre
          textarea#message(
            name="message",
            v-model="message",
            placeholder="digite seu e-mail",
            v-validate="'required'",
            :class="{'error': submitted && errors.has('message') }"
          )
          span.help(v-if="submitted") {{ errors.first('message') }}

        .field
          button(type="submit").bt Enviar mensagem
            Send.icon

    footer.content.col-4.col-offset-4.col-tp-8.col-tp-offset-2.col-m-12.col-m-offset-0
      .row
        hr
        small Copyright © 2018 | Abner Simões
</template>

<script>
import './style.sass'
import {mapState} from 'vuex'
import * as emailjs from 'emailjs-com'
import Cover from '@/components/Cover/index.vue'
import Send from '@/assets/svg/md-send.svg'

emailjs.  init("user_O4EJZMjQPmzejmY39ePHb")

export default {
  name: 'Contact',
  components: {
    Cover,
    Send
  },
  data: () => {
    return {
      name: null,
      email: null,
      message: null,
      submitted: false,
      form: {
        status: null,
        feedback: ''
      }
    }
  },
  computed: {
    ...mapState({
      contact: state => state.contact
    })
  }, methods:{
    checkForm: function () {
      this.submitted = true

      this.$validator.validateAll().then((result) => {
        if (result) {
          // show loading
          this.$store.commit('setLoading', true)
          // send email
          return emailjs.sendForm('service_783k6ir','template_o51m3ww', '#form', 'user_O4EJZMjQPmzejmY39ePHb')
          .then(() => {
            this.resetData()
            this.feedback(true, 'Mensagem enviada com sucesso!')
          }, () => {
            this.feedback(false, 'Falha ao enviar sua mensagem. Tente novamente!')
          })
        }
      })
    },
    feedback(status, feedback) {
      window.scrollTo(0,0)
      this.$store.commit('setLoading', false)
      this.form = {
        status,
        feedback
      }
    },
    resetData() {
      this.nome = null
      this.email = null
      this.mensagem = null
      this.submitted = false
      setTimeout(() => {
        this.form = {
          status: null,
          feedback: ''
        }
      }, 5000)
    }
  },
  mounted () {
    this.$store.commit('setLoading', false)
  }
}
</script>